import {PLANET_HD_EARLIEST_CAMPAIGN_YEAR, isPlanetHdDateAllowed} from '../Images/planetHdAcquisitionQuery'
import {REMOTE_SENSING_DATE_STATES} from '../Images/remoteSensingDateModel'

const DISCOVERABLE_CAMPAIGN_STATUSES = new Set([
  REMOTE_SENSING_DATE_STATES.CANDIDATE,
  REMOTE_SENSING_DATE_STATES.PREPARING,
  REMOTE_SENSING_DATE_STATES.READY,
])

export const getPlanetHdCampaignYear = (dateValue, monthFrom, monthTo) => {
  const [yearValue, monthValue] = String(dateValue || '').slice(0, 10).split('-')
  const year = Number(yearValue)
  const month = Number(monthValue)
  const startMonth = Number(monthFrom)
  const endMonth = Number(monthTo)

  if (![year, month, startMonth, endMonth].every(Number.isFinite)) {
    return null
  }

  if (startMonth > endMonth) {
    if (month >= startMonth) {
      return year
    }
    if (month <= endMonth) {
      return year - 1
    }
    return null
  }

  return month >= startMonth && month <= endMonth ? year : null
}

export const getAvailablePlanetHdCampaignYears = (
  items,
  monthFrom,
  monthTo
) => Array.from(new Set(
  (items || [])
    .filter((item) => DISCOVERABLE_CAMPAIGN_STATUSES.has(item.status) && isPlanetHdDateAllowed(item.date))
    .map((item) => getPlanetHdCampaignYear(item.date, monthFrom, monthTo))
    .filter((year) => year >= PLANET_HD_EARLIEST_CAMPAIGN_YEAR)
)).sort((left, right) => left - right)
